<div class="ft-dropdown" [class.active]="open()">
  <a class="ft-dropdown-toggle" (click)="toggle($event)">
    <span>{{ displayText() }}</span> <i class="ft-icn-caret-down"></i></a>
  <ul class="ft-dropdown-menu">
    @for (item of items(); track item) {
      <li (click)="select(item)"><a>{{ item[value()] }}</a></li>
    }
  </ul>
</div>
